export const Pokedex: import('../../../sim/dex-species').ModdedSpeciesDataTable = {
	seaking: {
		inherit: true,
		baseStats: { hp: 80, atk: 92, def: 65, spa: 65, spd: 80, spe: 98 },
	},
	clefablemega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	victreebelmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	starmiemega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	skarmorymega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	scolipedemega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	scraftymega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	emboarmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	eelektrossmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	chesnaughtmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	delphoxmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	greninjamega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	pyroarmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	barbaraclemega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	hawluchamega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	raichumegax: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	chimechomega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	baxcaliburmega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	zeraoramega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	absolmegaz: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	staraptormega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	golisopodmega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	meowsticfmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	crabominablemega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	golurkmega: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	garchompmegaz: {
		inherit: true,
		abilities: { 0: "Huge Power" },
	},
	lucariomegaz: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	raichumegay: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	falinksmega: {
		inherit: true,
		abilities: { 0: "No Retreat" },
	},
	drampamega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	zygardemega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	dragalgemega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	darkraimega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	heatranmega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	floettemega: {
		inherit: true,
		abilities: { 0: "Regenerator" },
	},
	chandeluremega: {
		inherit: true,
		abilities: { 0: "Shadow Tag" },
	},
	lickitung: {
		inherit: true,
		abilities: { 0: "Own Tempo", 1: "Oblivious", H: "Chaos Saliva" },
	},
	mewtwo: {
		inherit: true,
		abilities: { 0: "Pressure", 1: "Neuroforce", H: "Unnerve" },
	},
	scovillainmega: {
		inherit: true,
		abilities: { 0: "Contrary" },
	},
	mew: {
		inherit: true,
		abilities: { 0: "Synchronize", 1: "Neuroforce" },
	},
	smeargle: {
		inherit: true,
		abilities: { 0: "Own Tempo", 1: "Prankster", H: "Moody" },
	},
	swampert: {
		inherit: true,
		abilities: { 0: "Torrent", 1: "Sap Sipper", H: "Damp" },
	},
	bibarel: {
		inherit: true,
		baseStats: { hp: 159, atk: 85, def: 60, spa: 55, spd: 60, spe: 151 },
	},
	skuntank: {
		inherit: true,
		baseStats: { hp: 103, atk: 93, def: 67, spa: 106, spd: 61, spe: 84 },
		abilities: { 0: "Stench", 1: "Aftermath", H: "Mega Launcher" },
	},
	rampardos: {
		inherit: true,
		baseStats: { hp: 97, atk: 225, def: 30, spa: 65, spd: 30, spe: 58 },
		abilities: { 0: "Rocky Payload", H: "Sheer Force" },
	},
	gallademega: {
		inherit: true,
		abilities: { 0: "Sharpness" },
	},
	garchompmega: {
		inherit: true,
		abilities: { 0: "Sand Rush" },
	},
	dusknoir: {
		inherit: true,
		abilities: { 0: "Damp" },
	},
	lickilicky: {
		inherit: true,
		abilities: { 0: "Own Tempo", 1: "Oblivious", H: "Chaos Saliva" },
	},
	regigigas: {
		inherit: true,
		abilities: { 0: "Slow Start", H: "Fast Start" },
	},
	serperior: {
		inherit: true,
		types: ['Grass', 'Dragon'],
		baseStats: { hp: 75, atk: 75, def: 95, spa: 105, spd: 95, spe: 113 },
	},
	simisage: {
		inherit: true,
		baseStats: { hp: 120, atk: 120, def: 120, spa: 120, spd: 120, spe: 120 },
	},
	excadrillmega: {
		inherit: true,
		abilities: { 0: "It's Excadrillin' Time!" },
	},
	chandelure: {
		inherit: true,
		abilities: { 0: "Flash Fire", 1: "Flame Body", H: "Shadow Tag" },
	},
	delphox: {
		inherit: true,
		abilities: { 0: "Blaze", H: "Discourage" },
	},
	clawitzer: {
		inherit: true,
		abilities: { 0: "Super Mega Launcher" },
	},
	malamar: {
		inherit: true,
		baseStats: { hp: 101, atk: 112, def: 88, spa: 68, spd: 75, spe: 73 },
	},
	malamarmega: {
		inherit: true,
		baseStats: { hp: 101, atk: 122, def: 88, spa: 98, spd: 120, spe: 88 },
		abilities: { 0: "Contrary" },
	},
	incineroar: {
		inherit: true,
		types: ['Fire', 'Fighting'],
	},
	incineroar2: {
		num: 2000,
		name: "Incineroar 2",
		types: ["Ghost", "Steel"],
		genderRatio: { M: 0.875, F: 0.125 },
		baseStats: { hp: 95, atk: 115, def: 90, spa: 80, spd: 90, spe: 60 },
		abilities: { 0: "Intimidate 2" },
		heightm: 1.8,
		weightkg: 83,
		color: "Red",
		eggGroups: ["Field"],
	},
	celesteela: {
		inherit: true,
		baseStats: { hp: 5, atk: 5, def: 5, spa: 5, spd: 5, spe: 5 },
	},
	hatterene: {
		inherit: true,
		types: ['Psychic', 'Dark'],
	},
	glimmora: {
		inherit: true,
		baseStats: { hp: 106, atk: 150, def: 70, spa: 194, spd: 120, spe: 140 },
	},
	glimmoramega: {
		inherit: true,
		baseStats: { hp: 106, atk: 185, def: 85, spa: 214, spd: 145, spe: 155 },
		abilities: { 0: "Regenerator" },
	},
	tatsugiri: {
		inherit: true,
		abilities: { 0: "Commander", 1: "Parental Bond", H: "Storm Drain" },
	},
	tatsugiridroopy: {
		inherit: true,
		abilities: { 0: "Commander", 1: "Parental Bond", H: "Storm Drain" },
	},
	tatsugiristretchy: {
		inherit: true,
		abilities: { 0: "Commander", 1: "Parental Bond", H: "Storm Drain" },
	},
	tatsugiricurlymega: {
		inherit: true,
		abilities: { 0: "Parental Bond" },
	},
	tatsugiridroopymega: {
		inherit: true,
		abilities: { 0: "Parental Bond" },
	},
	tatsugiristretchymega: {
		inherit: true,
		abilities: { 0: "Parental Bond" },
	},
	calyrex: {
		num: 898,
		name: "Calyrex",
		types: ["Psychic", "Grass"],
		gender: "N",
		baseStats: { hp: 100, atk: 80, def: 80, spa: 80, spd: 80, spe: 80 },
		abilities: { 0: "Unnerve" },
		heightm: 1.1,
		weightkg: 7.7,
		color: "Green",
		eggGroups: ["Undiscovered"],
		tags: ["Restricted Legendary"],
		otherFormes: ["Calyrex-Ice", "Calyrex-Shadow", "Calyrex-Monarch"],
		formeOrder: ["Calyrex", "Calyrex-Ice", "Calyrex-Shadow", "Calyrex-Monarch"],
	},
	calyrexmonarch: {
		num: 898,
		name: "Calyrex-Monarch",
		baseSpecies: "Calyrex",
		forme: "Monarch",
		types: ["Psychic", "Grass"],
		gender: "N",
		baseStats: { hp: 200, atk: 160, def: 160, spa: 160, spd: 160, spe: 160 },
		abilities: { 0: "As One (Calyrex)" },
		heightm: 2.2,
		weightkg: 15.4,
		color: "Green",
		eggGroups: ["Undiscovered"],
		changesFrom: "Calyrex",
	},
	spidops: {
		inherit: true,
		baseStats: { hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 0 },
	},
};
